import type { ListBuilderConfiguration } from '../types';

/**
 * Automation Flows list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const AUTOMATION_FLOWS_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-automation-flows',
			cacheTTL: 600000,
			name: 'All Flows',
			type: 'default',
			active: true,
			columns: [
				{
					id: 'flow-name',
					headers: [
						{
							id: 'flow-name-header',
							text: 'Flow Name',
						},
					],
					fields: [
						{
							id: 'name-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'name',
									objectTable: 'automation_flow',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
							link: {
								type: 'object',
								enabled: true,
							},
						},
						{
							id: 'line-break-1',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							displayStyle: 'line_break',
						},
						{
							id: 'description-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'description',
									objectTable: 'automation_flow',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: true,
				},
				{
					id: 'active-version',
					headers: [
						{
							id: 'active-version-header',
							text: 'Active Version',
						},
					],
					fields: [
						{
							id: 'active-version-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'activeVersionDisplay',
									objectTable: 'automation_flow',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
					width: 150,
				},
				{
					id: 'dates',
					headers: [
						{
							id: 'dates-header',
							text: 'Created / Modified',
						},
					],
					fields: [
						{
							id: 'created-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'createdDate',
									objectTable: 'automation_flow',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'date',
						},
						{
							id: 'line-break-dates',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							displayStyle: 'line_break',
						},
						{
							id: 'modified-date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'modifiedDate',
									objectTable: 'automation_flow',
								},
							},
							styleConfig: {
								size: 'xs',
								colorRule: {
									type: 'muted',
								},
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					sortFields: [
						{
							objectTable: 'automation_flow',
							fieldName: 'createdDate',
							direction: 'DESC',
						},
					],
					width: 150,
				},
				{
					id: 'actions',
					headers: [
						{
							id: 'actions-header',
							text: 'Actions',
						},
					],
					fields: [
						{
							id: 'actions-dropdown',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'actions_dropdown',
							dropdownActions: [
								{
									id: 'view-executions-action',
									label: 'View Executions',
									iconName: 'chart-line',
									callbackName: 'viewExecutions',
								},
								{
									id: 'edit-action',
									label: 'Edit',
									iconName: 'edit',
									callbackName: 'edit',
								},
								{
									id: 'copy-action',
									label: 'Copy',
									iconName: 'copy',
									callbackName: 'copy',
								},
								{
									id: 'delete-action',
									label: 'Delete',
									iconName: 'trash',
									callbackName: 'delete',
									danger: true,
								},
							],
						},
					],
					sortable: false,
					width: 100,
					alignment: 'center',
					verticalAlignment: 'middle',
				},
			],
			defaultSortId: 'flow-name',
			sortOrder: 0,
		},
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: [
			'automationKeywords',
			'automationCreatedDate',
			'automationModifiedDate',
		],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/automation/flows/:id',
			objectLabel: 'Flow',
			objectTable: '_automation_flow',
			selectedFields: [
				{
					fieldName: 'id',
					fieldLabel: 'ID',
				},
				{
					fieldName: 'name',
					fieldLabel: 'Name',
				},
				{
					fieldName: 'description',
					fieldLabel: 'Description',
				},
				{
					fieldName: 'activeVersionDisplay',
					fieldLabel: 'Active Version',
				},
				{
					fieldName: 'createdDate',
					fieldLabel: 'Created Date',
				},
				{
					fieldName: 'modifiedDate',
					fieldLabel: 'Modified Date',
				},
			],
		},
	],
};
